export enum InverterManufacturer {
  solarEdge = 'SolarEdge',
  enphase = 'Enphase',
  generac = 'Generac',
  tesla = 'Tesla',
  tigo = 'Tigo',
}

export enum PanelManufacturer {
  csiSolar = 'CSI Solar (Canadian Solar)',
  hyundaiEnergySolutions = 'Hyundai Energy Solutions',
  jASolar = 'JA Solar',
  jinkoSolar = 'Jinko Solar',
  longi = 'LONGi',
  qcells = 'Qcells',
  recSolar = 'REC Solar',
  silfabSolar = 'Silfab Solar',
  trinaSolar = 'Trina Solar',
  vsun = 'VSUN',
  missionSolarEnergy = 'Mission Solar Energy',
  panasonic = 'Panasonic',
  znshineSolar = 'ZNShine Solar',
  segSolar = 'SEG Solar',
}

export enum MountingManufacturer {
  ironRidge = 'IronRidge',
  unirac = 'Unirac',
  snapNRack = 'SnapNRack',
  k2 = 'K2',
  ecoFasten = 'EcoFasten',
  roofTech = 'Roof Tech',
  pegasus = 'Pegasus',
  s5 = 'S-5!',
  quickMount = 'QuickMount',
}

export enum StorageManufacturer {
  solarEdge = 'SolarEdge',
  tesla = 'Tesla',
  enphase = 'Enphase',
  generac = 'Generac',
}

export enum HVACManufacturer {
  trane = 'Trane',
  americanStandard = 'American Standard',
  /** Same company as American Standard */
  runTru = 'Run-Tru',
  ameristar = 'Ameristar',
  daikin = 'Daikin',
  goodman = 'Goodman',
  amana = 'Amana',
  samsung = 'Samsung',
  mitsubishiElectric = 'Mitsubishi Electric',
  lennox = 'Lennox',
  carrier = 'Carrier',
  bryant = 'Bryant',
  rheem = 'Rheem',
  fujitsu = 'Fujitsu',
  bosch = 'Bosch',
  york = 'York',
  lg = 'LG',
  gree = 'Gree',
}

export enum GeothermalManufacturer {
  climatemaster = 'ClimateMaster',
  enertech = 'Enertech',
  geoComfort = 'GeoComfort',
  waterFurnace = 'WaterFurnace',
}

export enum GeneratorManufacturer {
  generac = 'Generac',
}

export enum WaterHeaterManufacturer {
  aoSmith = 'A.O. Smith',
  americanStandard = 'American Standard',
  americanWaterHeaters = 'American Water Heaters',
  bosch = 'Bosch',
  bradfordWhite = 'Bradford White',
  cala = 'Cala',
  ecosmart = 'EcoSmart',
  geAppliances = 'GE Appliances',
  kenmore = 'Kenmore',
  navien = 'Navien',
  rheem = 'Rheem',
  rinnai = 'Rinnai',
  whirlpool = 'Whirlpool',
}
